import { render, staticRenderFns } from "./Blazon1.vue?vue&type=template&id=44869d4d&"
import script from "./Blazon1.vue?vue&type=script&lang=js&"
export * from "./Blazon1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports